module.exports = __webpack_public_path__ + "img/double-arrow.7c60cf24.svg";